export const RESEND_AA_WELCOME_EMAIL_MODAL_NAME =
  'RESEND_AA_WELCOME_EMAIL_MODAL_NAME';
